import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {apiGetSubjectById} from "../Actions";
import Toast from "cogo-toast";
import Loader from "../../../components/loader";
import Widget from "../../../components/widget";
import GetTariffList from "./GetTariffList";
import {IconTabs} from "../../../components/tabs";
import GetEventsList from "./GetEventsList";


const TestConnection = () => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);

    const {id} = useParams();

    useEffect(() => {
        id && getSubjects()
    }, [])

    const getSubjects = () => {
        setLoading(true)
        setData(null)
        apiGetSubjectById((id), (data) => {
            setData(data[0])
            setLoading(false)
        }, (err) => {
            switch (err.error.type) {
                default:
                    Toast.error("Neočekávaná chyba.")
            }
            setLoading(false)
        })
    }

    if (loading) {
        return <Loader/>
    }

    const getTabs = () => {
        let tabs = [];
        let index = 0;

        if (data?.connections?.key === 'ELVIS' || data?.connections?.key === 'ENIGOO' || data?.connections?.key === 'COMINFO') {
            tabs.push({
                index: index,
                title: (<span className={"ml-2"}>Získání tarifů</span>),
                content: <GetTariffList subject={data}/>
            })
            index++;
        }

        tabs.push({
            index: index,
            title: (<span className={"ml-2"}>Nahrané události</span>),
            content: <GetEventsList subject={data}/>
        })
        return tabs;
    }

    if (!data) return null

    return (
        <>
            <Widget>
                <div className={"flex flex-row text-black"}>
                    <h5 className={"align-middle"}>{data?.name}({data?.connections?.key})</h5>
                    <span className="ml-auto"></span>
                </div>


            </Widget>

            <IconTabs tabs={getTabs()}/>
        </>
    )
}

export default TestConnection;
